import { useMemo } from 'react';
import {
  TtOrderViewResult,
  TtOrderFilter,
  computeSummaryStats,
} from '../transform';

interface TTSummarySectionProps {
  orderView: TtOrderViewResult;
  activeFilter: TtOrderFilter;
  isLoading: boolean;
}

export function TTSummarySection({
  orderView,
  activeFilter,
  isLoading,
}: TTSummarySectionProps) {
  const stats = useMemo(
    () => computeSummaryStats(orderView, activeFilter),
    [orderView, activeFilter]
  );

  if (isLoading) {
    return (
      <div className="flex flex-wrap gap-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground">Loading...</span>
            <div className="h-5 w-12 bg-muted animate-pulse rounded" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {/* Summary Stats */}
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
        <div className="flex flex-col items-center gap-2">
          <span className="text-xs text-muted-foreground whitespace-nowrap">
            Missing Customer ID (Applicable):
          </span>
          <span className="text-md font-bold text-orange-600">
            {stats.totalMissingApplicable}
          </span>
        </div>

      {/* Orders by Account Breakdown (for active filter) */}
{stats.byAccount.length > 0 && (
        <div>
          <div className="text-xs font-medium text-muted-foreground mb-1">
            Orders by Account (Current Filter)
          </div>
          <div className="flex flex-wrap gap-2">
            {stats.byAccount.map(({ account, count }) => (
              <div
                key={account}
                className="flex items-center gap-1.5 px-2 py-1 bg-muted rounded-md"
              >
                <span className="text-xs" title={account}>
                  {account}:
                </span>
                <span className="text-xs font-semibold">{count}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      </div>


    </div>
  );
}
